export default function Footer() {
  return <footer>&#169; 2024 FlexiSpace</footer>;
}
